import React, { useEffect } from 'react'
import { motion } from "framer-motion";
import { ImageBuffer } from '../..'
import { img2 } from '../../../assets'
import { CallRounded, MedicationLiquidRounded } from '@mui/icons-material';

import './hero.css'

const Hero = () => {
    
  return (
    <>
        <section id="hero" className="hero-wrapper">
            <main className="hero-container">
                <div className="hero-container-left">
                    <button className="hero-btn-cover" type="button">
                        <span>PERSONALIZED CARE WITH</span>
                        <span className="hero-svg-arrow">
                            <MedicationLiquidRounded />
                        </span>
                    </button>
                    <div className=''>
                        <motion.h1 
                            initial={{opacity: 0, y: 40}} 
                            whileInView={{opacity: 1, y: 0}} 
                            transition={{duration: 0.6, delay: 0.8}}
                            viewport={{once: true}}
                            className="hero-title-text">
                                Shalom Springs of
                            <span className="hero-sub-text">
                                Plano.
                            </span>
                        </motion.h1>
                        <motion.p 
                            initial={{opacity: 0, y: 30}} 
                            whileInView={{opacity: 1, y: 0}} 
                            transition={{duration: 0.5, delay: 1}}
                            viewport={{once: true}}
                            className='hero-title-description'>At Shalom Springs of Plano, we provide compassionate and personalized care for seniors in a warm and supportive community. Learn more about our residential care home and how we can support you and your loved ones.
                        </motion.p>
                    </div>
                    <a href="tel:+14693262931" className="hero-call-to-action-link">
                        <CallRounded className="hero-call-to-action-btn" />
                        Call Today: 
                        <span className='hero-call-to-action-link-title'> +214-254-6367</span>
                    </a>
                </div>
                <motion.div 
                    initial={{opacity: 0, scale: 0.9}} 
                    whileInView={{opacity: 1, scale: 1}} 
                    transition={{duration: 0.6, delay: 2}}
                    viewport={{once: true}}
                    aria-label="Photos of leaders" 
                    className="hero-container-right"
                >
                    <ImageBuffer src={img2} alt='' className="hero-image-right" />
                </motion.div>
            </main>
        </section>
    </>
  )
}

export default Hero